import { Box, Button, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import React, { useState } from 'react'
import { useLocation } from "react-router-dom";
import { useAppDispatch } from '../../store/hooks';
import { useRefresh, useUnselectAll } from 'react-admin';
import { setCustomSelectOpen } from '../../store/reducers/customSelect';
import ResourceSelectDialog from './ResourceSelectDialog';
 import { maskPhoneNumber } from "../../utils/PhoneNumberUtils";
import Cooks from '../Cooks/Cooks';
import EventBus from '../../EventBus';
import { EventBusEventsEnum } from '../../enums/EventBusEventsEnum';
import { CustomSnackbarTypes } from './CustomSnackBar';
import { OneMealService } from '../../services/OneMealService';
import CircularLoader from './CircularLoader';
import { useNavigate } from "react-router-dom";

interface AssignMultipleLocationState {
    selectedIds: number[];
}
const oneMealService = new OneMealService();

function AssignCookToMultpleOms(props: any) {
    const location = useLocation() as { state: AssignMultipleLocationState };
    const { selectedIds } = location.state || {};
    const navigate = useNavigate();

    const [selectedCook, setSelectedCook] = useState<any>(null);
    const [isConveyanceAllowed, setIsConveyanceAllowed] = useState<boolean>(false);
  
    const [loading, setLoading] = useState<any>(false);
    const dispatch = useAppDispatch();
    const refresh = useRefresh();
    const unselectAll = useUnselectAll("OneMealService");

    const handleClose = async (recordData: any) => {
        setSelectedCook(recordData);
    };

    const assignCook = async () => {
        let successCount = 0;
        let failure = 0;

        const assignCookToServices = async () => {
            console.log("Selected IDs:", selectedIds);
            
          const promises = selectedIds.map(async (element: number) => {
            const payload = {
              cookId: Number(selectedCook.id),
              oneMealServiceCookCut: "0",
              allocationNotes: "",
              isConveyanceAllowed: isConveyanceAllowed,
            };

            try {
              setLoading(true);
              const res = await oneMealService.assignCookToOneMealService(
                Number(element),
                payload
              );

              if (res.status === 200) {
                await oneMealService.acceptOneMealService(Number(element), {
                  accepted: true,
                  reason: "Accepted",
                });
                successCount++;
              }
            } catch (error) {
              failure++;
              console.error(error);
            }
          });

          await Promise.all(promises);
          setLoading(false);
          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
            message: `Cook Allocated Successfully for ${successCount} visits and failed for ${failure} visits`,
            type: CustomSnackbarTypes.SUCCESS,
          });
        }
        await assignCookToServices();
        unselectAll();
        refresh();
        navigate('/OneMealService');
    }
    

    const handleSelectCook = () => {
        dispatch(
          setCustomSelectOpen({
            open: true,
          })
        );
    };

  return (
    <div
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    background: "linear-gradient(135deg, #eef2f7, #dbeafe)",
  }}
>
  <ResourceSelectDialog
    name={"Cooks"}
    list={Cooks}
    onClose={handleClose}
  />

  {!loading ? (
    <Box
      width="42%"
      sx={{
        backdropFilter: "blur(10px)",
        background: "rgba(255,255,255,0.85)",
        borderRadius: "28px",
        boxShadow: "0 25px 50px rgba(0,0,0,0.18)",
        overflow: "hidden",
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #2563eb, #1e40af)",
          color: "#fff",
          py: 2.5,
          textAlign: "center",
          fontSize: "2rem",
          fontWeight: 700,
        }}
      >
        Assign Cook
      </Box>

      <Box px={4} py={3}>
        {/* SELECTED IDS */}
        <Box fontSize="1.3rem" fontWeight={700} mb={2}>
          Selected Orders
        </Box>

        <Box display="flex" flexWrap="wrap" gap={1.5}>
          {selectedIds?.length ? (
            selectedIds.map((id) => (
              <Box
                key={id}
                sx={{
                  px: 3,
                  py: 0.7,
                  borderRadius: "999px",
                  background:
                    "linear-gradient(135deg, #60a5fa, #3b82f6)",
                  color: "#fff",
                  fontWeight: 600,
                  boxShadow: "0 6px 15px rgba(59,130,246,0.45)",
                }}
              >
                #{id}
              </Box>
            ))
          ) : (
            <Box color="text.secondary">No IDs selected</Box>
          )}
        </Box>

        {/* SELECT COOK */}
        <Box mt={4}>
          <Button
            fullWidth
            sx={{
              py: 1.4,
              fontSize: "1rem",
              fontWeight: 700,
              borderRadius: "14px",
              textTransform: "none",
              background:
                "linear-gradient(135deg, #2563eb, #3b82f6)",
              boxShadow: "0 10px 25px rgba(37,99,235,0.4)",
            }}
            onClick={handleSelectCook}
            variant="contained"
          >
            Select Cook
          </Button>
        </Box>
        <FormGroup>
          <FormControlLabel label='Conveyance Allowed' control={
            <Checkbox checked={isConveyanceAllowed} onClick={(e)=>{
              EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                message: "Are you sure you want to change Conveyance Allowed",
                onClose: (confirmed: boolean) => {
                  if (confirmed) {
                    setIsConveyanceAllowed(!isConveyanceAllowed);
                  }
                },
                title: "Confirmation"
              });
            }}/>
          }/>
      </FormGroup>

        {/* SELECTED COOK CARD */}
        {selectedCook && (
          <Box
            mt={4}
            sx={{
              borderRadius: "18px",
              p: 2.5,
              background:
                "linear-gradient(135deg, #e0f2fe, #bae6fd)",
              boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
            }}
          >
            <Box fontSize="1.2rem" fontWeight={700} mb={1}>
              Selected Cook
            </Box>

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              fontWeight={600}
            >
              <Box>
                {selectedCook?.cookFullProfile?.firstName}{" "}
                {selectedCook?.cookFullProfile?.lastName}
              </Box>
              <Box>
                ⭐{" "}
                {
                  selectedCook?.cookFullProfile
                    ?.overallCustomerRating?.chefitRating
                }
              </Box>
              <Box>{maskPhoneNumber(selectedCook?.mobile)}</Box>
            </Box>
          </Box>
        )}

        {/* SUBMIT */}
        <Box mt={5} textAlign="center">
          <Button
            sx={{
              width: "65%",
              py: 1.5,
              fontSize: "1.1rem",
              fontWeight: 800,
              borderRadius: "999px",
              textTransform: "none",
              background:
                "linear-gradient(135deg, #16a34a, #22c55e)",
              boxShadow: "0 12px 30px rgba(34,197,94,0.45)",
            }}
            onClick={assignCook}
            variant="contained"
          >
            Confirm & Assign
          </Button>
        </Box>
      </Box>
    </Box>
  ) : (
    <CircularLoader />
  )}
</div>
  )
}
export default AssignCookToMultpleOms
